import React, { useState, useEffect } from "react";
import backButton from "../assets/backButton.svg";
import "./Css/Newonboading.css";
import "./Css/Calender.css";
import "./Css/Settings.css";
import BorderedGlobe from "../assets/borderedGlobe2.svg";
import BorderedOn from "../assets/on1.svg";
import CrossedGlobe from "../assets/crossedGlobe.svg";
import Watch from "../assets/watchBordered.svg";
import CrossedOn from "../assets/crossedON.svg";
import AddIcon from "../assets/addIcon.png";
import PrevArrow from "../assets/keyboard_arrow_up_prev.svg";
import NextArrow from "../assets/keyboard_arrow_up_nxt.svg";
import LKTicn from "../assets/LKTicn.svg";
import DeleteIcon from "../assets/newDelet.svg";
import { Modal, Button } from "react-bootstrap";
import $ from "jquery";
import {
  server_post_data,
  view_week_all_timing,
  save_update_week_timing,
} from "../ServiceConnection/serviceconnection.js";
import { retrieveData } from "../LocalConnection/LocalConnection";
import { handleError } from "../CommonJquery/CommonJquery";
import { useLocation } from "react-router-dom";
let staff_id = "0";
let default_restaurant_id_staff = "0";
const Onboadingstep9 = ({ nextStep, prevStep }) => {
  staff_id = retrieveData("staff_id");
  default_restaurant_id_staff = retrieveData("default_restaurant_id_staff");
  const location = useLocation();
  const [selectedInterval, setSelectedInterval] = useState(15);
  const [isOnlineOn, setIsOnlineOn] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [isSpecialOnlineOn, setIsSpecialOnlineOn] = useState([]);
  const [isRestroOpeninside, setIsRestroOpeninside] = useState([]);
  const [dataloop, setdataloop] = useState([]);
  const [dayData, setdayData] = useState([]);

  const [dataloopindex, setdataloopindex] = useState(1);
  const [dataloopdetails, setdataloopdetails] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [isChecked, setIsChecked] = useState([]);
  const [isWeekOnlineChecked, setIsWeekOnlineChecked] = useState([]);
  const [isWeekCloseChecked, setIsWeekCloseChecked] = useState([]);

  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    var form_data = new FormData();
    form_data.append("default_restaurant_id", default_restaurant_id_staff);
    form_data.append("from_come", "1");
    await server_post_data(view_week_all_timing, form_data)
      .then((Response) => {
        //console.log(Response.data);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          /// console.log(Response.data.message);
          if (Response.data.message.data_timedata.length > 0) {
            setdataloop(Response.data.message.data_timedata);

            const daysloop = [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ];
            const dayValuePairs = daysloop.map((day, index) => {
              return { day: day, value: index };
            });

            setdayData(dayValuePairs); // Assuming you still want to set dayData

            setdataloopdetails(Response.data.message.data_timedatadetails);
            setdataloopindex(Response.data.message.data_timedata.length);
            setSelectedInterval(Response.data.message.time_slot_minutes);

            const checkedValues = Response.data.message.data_timedata.map(
              (item) => (item.checked ? true : false)
            );
            setIsChecked(checkedValues);
          }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const deletenewrow = () => {
    $(".timeRow" + selectedRow).remove();
    setModalShow1(false);
  };
  const handleClose1 = () => setModalShow1(false);
  const handleShow1 = (index) => {
    setModalShow1(true);
    setSelectedRow(index);
  };

  const addnewrow = (indxbtn) => {
    console.log(indxbtn);
    const htmlelement = $(".timeRow" + indxbtn).html();
    const forhtml = $(".Add_time_row" + indxbtn).attr("forhtml");
    //console.log(htmlelement);
    setdataloopindex(dataloopindex + 1);
    //$('.mainhd').append('<div className=timeRow'+dataloopindex+'>'+htmlelement+'</div>');

    const newRow = $(
      `<div class="timeRow${dataloopindex} timeRow "  id="timeRow${dataloopindex}">${htmlelement}</div>`
    );
    //$(".mainhd").append(newRow);
    $(".weekdayDiv" + forhtml).append(newRow);
    $(".timeRow" + dataloopindex)
      .find(".accordion-button")
      .attr("data-bs-target", `#panelsStayOpen-collapseOne${dataloopindex}`);
    $(".timeRow" + dataloopindex)
      .find(".accordion-button")
      .attr("aria-controls", `#panelsStayOpen-collapseOne${dataloopindex}`);
    $(".timeRow" + dataloopindex)
      .find(".accordion-collapse")
      .attr("id", `panelsStayOpen-collapseOne${dataloopindex}`);

    $(".timeRow" + dataloopindex)
      .find(".timeli")
      .addClass("timeli_hide");
    $(".timeRow" + dataloopindex)
      .find(".guest_arrival" + indxbtn)
      .removeClass("guest_arrival" + indxbtn)
      .addClass("guest_arrival" + dataloopindex);
    $(".timeRow" + dataloopindex)
      .find(".Add_time_row" + indxbtn)
      .removeClass("Add_time_row" + indxbtn)
      .addClass("Add_time_row" + dataloopindex)
      .remove();
    $(".timeRow" + dataloopindex)
      .find(".Delete_time_row" + indxbtn)
      .removeClass("Delete_time_row" + indxbtn)
      .removeClass("hidden")
      .addClass("Delete_time_row" + dataloopindex)
      .show()
      .on("click", function (e) {
        handleShow1(dataloopindex);
      });
    $(".timeRow" + dataloopindex)
      .find(".start_time" + indxbtn)
      .removeClass("start_time" + indxbtn)
      .addClass("start_time" + dataloopindex)
      .each(function () {
        $(this).on("input", function (e) {
          generateTimings(dataloopindex);
        });
      });
    $(".timeRow" + dataloopindex)
      .find(".end_time" + indxbtn)
      .removeClass("end_time" + indxbtn)
      .addClass("end_time" + dataloopindex)
      .each(function () {
        $(this).on("input", function (e) {
          generateTimings(dataloopindex);
        });
      });
    isChecked[dataloopindex] = false;
    $(".timeRow" + dataloopindex)
      .find(".hidden-checkbox" + indxbtn)
      .removeClass("hidden-checkbox" + indxbtn)
      .addClass("hidden-checkbox" + dataloopindex)
      .attr("id", "time_checkbox" + dataloopindex)
      .prop("checked", isChecked[dataloopindex])
      .each(function () {
        $(this).on("change", function (e) {
          handleCheckboxChange(e, dataloopindex);
          ///console.log(e);
        });
      });

    $(".timeRow" + dataloopindex)
      .find(".checkbox-labelTiming")
      .attr("for", "time_checkbox" + dataloopindex);

    $(".timeRow" + dataloopindex)
      .find(".discount_input_head" + indxbtn)
      .removeClass("discount_input_head" + indxbtn)
      .addClass("discount_input_head" + dataloopindex)
      .each(function () {
        $(this).on("blur", function (e) {
          discount_totl_st_chng(e, dataloopindex, "discount", "default");
        });
      });

    $(".timeRow" + dataloopindex)
      .find(".total_seat_input_head" + indxbtn)
      .removeClass("total_seat_input_head" + indxbtn)
      .addClass("total_seat_input_head" + dataloopindex)
      .each(function () {
        $(this).on("blur", function (e) {
          discount_totl_st_chng(e, dataloopindex, "total_seat", "default");
        });
      });

    $(".timeRow" + dataloopindex)
      .find(".discount_input" + indxbtn)
      .removeClass("discount_input" + indxbtn)
      .addClass("discount_input" + dataloopindex)
      .each(function () {
        $(this).on("blur", function (e) {
          discount_totl_st_chng(e, dataloopindex, "discount", "inside_input");
        });
      });

    $(".timeRow" + dataloopindex)
      .find(".total_seat_input" + indxbtn)
      .removeClass("total_seat_input" + indxbtn)
      .addClass("total_seat_input" + dataloopindex)
      .each(function () {
        $(this).on("blur", function (e) {
          discount_totl_st_chng(e, dataloopindex, "total_seat", "inside_input");
        });
      });

    $(".timeRow" + dataloopindex)
      .find(".Online_Booking_Off")
      .each(function () {
        const buttonElement = $(this);
        const forAttr = buttonElement.attr("for");
        let key = `${dataloopindex}_${forAttr}`;
        let old_key = `${indxbtn}_${forAttr}`;
        buttonElement.attr(
          "title",
          !isSpecialOnlineOn[key] ? "Online Booking ON" : "Online Booking Off"
        );

        buttonElement
          .find(".BorderedGlobe")
          .removeClass(`BorderedGlobe_${old_key} normal_hide`)
          .addClass(`BorderedGlobe_${key}`);
        buttonElement
          .find(".CrossedGlobe")
          .removeClass(`CrossedGlobe_${old_key}`)
          .addClass(`CrossedGlobe_${key} normal_hide`);
        buttonElement
          .find(".online_input_insde")
          .removeClass(`online_input_insde${old_key}`)
          .addClass(`online_input_insde${key}`)
          .val(isSpecialOnlineOn[key]);

        buttonElement.on("click", function (e) {
          handleSpecialHrBooking(dataloopindex, forAttr, 1);
        });
      });

    $(".timeRow" + dataloopindex)
      .find(".Close_Restaurant")
      .each(function () {
        const buttonElement = $(this);
        const forAttr = buttonElement.attr("for");

        let key = `${dataloopindex}_${forAttr}`;
        let old_key = `${indxbtn}_${forAttr}`;
        buttonElement.attr(
          "title",
          !isRestroOpeninside[key] ? "Close Restaurant" : "Open Restaurant"
        );

        buttonElement
          .find(".Restro_onbtn_insde")
          .removeClass(`Restro_onbtn_insde${old_key} normal_hide`)
          .addClass(`Restro_onbtn_insde${key}`);
        buttonElement
          .find(".Restro_closebtn_insde")
          .removeClass(`Restro_closebtn_insde${old_key}`)
          .addClass(`Restro_closebtn_insde${key} normal_hide`);
        buttonElement
          .find(".Restro_input_insde")
          .removeClass(`Restro_input_insde${old_key}`)
          .addClass(`Restro_input_insde${key}`)
          .val(isRestroOpeninside[key]);

        buttonElement.on("click", function (e) {
          handleRestroOpenInside(dataloopindex, forAttr, 1);
        });
      });
  };

  const generateTableTimings = () => {
    const Tabletimings = [];
    const startTime = new Date(2000, 0, 1, 0, 0); // Use an arbitrary date with 00:00 time
    const endTime = new Date(2000, 0, 1, 23, 45);

    let current = new Date(startTime);

    while (current <= endTime) {
      let formattedTime = current.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      formattedTime = formattedTime.replace(/^24/, "00");
      Tabletimings.push(formattedTime);
      current.setMinutes(current.getMinutes() + selectedInterval);
    }

    return Tabletimings;
  };

  const TabletimingsList = generateTableTimings();

  const generateTimings = (indxbtn) => {
    console.log(indxbtn);
    let start_time = document.querySelector(".start_time" + indxbtn).value;
    let end_time = document.querySelector(".end_time" + indxbtn).value;
    const start = new Date(`2000-01-01 ${start_time}`);
    const end = new Date(`2000-01-01 ${end_time}`);

    const newTimeList = [];

    while (start < end) {
      let formattedTime = start.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      formattedTime = formattedTime.replace(/^24/, "00");
      newTimeList.push(formattedTime);
      start.setMinutes(start.getMinutes() + selectedInterval);
    }

    let selectElement = $(".guest_arrival" + indxbtn);
    selectElement.empty(); //clear dropdown
    $(".timeRow" + indxbtn)
      .find(".timeli")
      .addClass("timeli_hide");
    let lstarrivllp = newTimeList.length - 4;
    const lstarrivllparray = [];

    for (let i = 0; i < newTimeList.length; i++) {
      $(".timeRow" + indxbtn)
        .find("." + newTimeList[i].replace(":", "_"))
        .removeClass("timeli_hide");
      if (i >= lstarrivllp) {
        lstarrivllparray.push(newTimeList[i]);
        selectElement.append(
          $("<option>", {
            value: newTimeList[i],
            text: newTimeList[i],
            selected: true,
          })
        );
      }
    }

    $(
      '[data-bs-target="#panelsStayOpen-collapseOne' + indxbtn + '"]'
    ).removeClass("collapsed");
    $("#panelsStayOpen-collapseOne" + indxbtn).addClass("show");
  };

  const discount_totl_st_chng = (event, indxbtn, flty, place) => {
    event.target.value = event.target.value.slice(0, 10).replace(/[^0-9]/g, "");
    if (event.target.value === "") {
      if (flty == "discount") {
        event.target.value = 0;
      } else {
        event.target.value = 0;
      }
    }
    if (place == "default") {
      if ($("#time_checkbox" + indxbtn).prop("checked") == true) {
        if (flty == "discount") {
          if (event.target.value < 0 || event.target.value == "") {
            event.target.value = 0;
            $(".discount_input" + indxbtn).val(0);
          }
          $(".discount_input" + indxbtn).val(event.target.value);
        } else {
          if (event.target.value < 1 || event.target.value == "") {
            event.target.value = 1;
            $(".total_seat_input" + indxbtn).val(1);
          }
          $(".total_seat_input" + indxbtn).val(event.target.value);
        }
      } else {
        if (flty == "discount") {
          if (event.target.value < 0 || event.target.value == "") {
            event.target.value = 0;
          }
        } else {
          if (event.target.value < 1 || event.target.value == "") {
            event.target.value = 1;
          }
        }
      }
    } else {
      if (flty == "discount") {
        if (event.target.value < 0 || event.target.value == "") {
          event.target.value = 0;
        }
      } else {
        if (event.target.value < 1 || event.target.value == "") {
          event.target.value = 1;
        }
      }
    }
  };

  const handleCheckboxChange = (event, indxbtn) => {
    let flgvl = 0;
    const disval = $(".discount_input_head" + indxbtn);
    const ttlstin = $(".total_seat_input_head" + indxbtn);
    if (event.target.checked == true) {
      if (disval.val() < 0 || disval.val() == "") {
        $(".hidden-checkbox" + indxbtn).prop("checked", false);
        disval.addClass("emptyInputError");
        flgvl = 1;
      } else {
        disval.removeClass("emptyInputError");
      }
      if (ttlstin.val() < 1 || ttlstin.val() == "") {
        $(".hidden-checkbox" + indxbtn).prop("checked", false);
        ttlstin.addClass("emptyInputError");
        flgvl = 1;
      } else {
        ttlstin.removeClass("emptyInputError");
      }
      if (flgvl == 0) {
        $(".discount_input" + indxbtn).val(disval.val());
        $(".total_seat_input" + indxbtn).val(ttlstin.val());
      }
    }

    if (flgvl == 0) {
      const updatedChecked = [...isChecked];
      updatedChecked[indxbtn] = event.target.checked;
      disval.removeClass("emptyInputError");
      ttlstin.removeClass("emptyInputError");
      setIsChecked(updatedChecked);
    }
  };

  const handleCheckboxWeekChange = (event, indxbtn) => {
    console.log(indxbtn);
    setIsWeekOnlineChecked((prevState) => {
      const updatedChecked = { ...prevState };
      updatedChecked[indxbtn] = !updatedChecked[indxbtn];
      return updatedChecked;
    });
  };

  const handleCheckboxWeekCloseChange = (event, indxbtn) => {
    console.log(indxbtn);
    setIsWeekCloseChecked((prevState) => {
      const updatedChecked = { ...prevState };
      updatedChecked[indxbtn] = !updatedChecked[indxbtn];
      const elements = document.querySelectorAll(
        ".weekdayDiv" + indxbtn + " .timeRow"
      );
      elements.forEach((element) => {
        if (!updatedChecked[indxbtn]) {
          element.classList.remove("unclickable");
        } else {
          element.classList.add("unclickable");
        }
      });
      return updatedChecked;
    });
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    const for_duplicate = [];
    const timeary = [];
    const week_online_data = [];
    const week_close_data = [];
    let count_array = 0;
    let vaild_data_one = 0;
    let vaild_data_three = 0;
    $(".emptyInputError").removeClass("emptyInputError");
    $(".online_input_insde_main").each(function (index) {
      week_online_data[$(this).attr("dayattr")] =
        $(this).val() === "true" ? "1" : "0";
      week_close_data[$(this).attr("dayattr")] =
        $(".Restro_input_insde" + $(this).attr("dayattr") + "_main").val() ===
        "true"
          ? "1"
          : "0";
    });
    $(".mainhd")
      .find(".timeRow")
      .each(function (index) {
        if (!$(this).hasClass("unclickable")) {
          const each_slot_timing = $(this).attr("id");
          const dayname = $(this).find(".dayname").val();
          if (!for_duplicate[dayname]) {
            for_duplicate[dayname] = [];
          }
          if (!timeary[dayname]) {
            timeary[dayname] = [];
          }

          for_duplicate[dayname][each_slot_timing] = [];
          timeary[dayname][each_slot_timing] = [];
          timeary[dayname][each_slot_timing]["timing"] = [];
          timeary[dayname][each_slot_timing]["discount"] = [];
          timeary[dayname][each_slot_timing]["total_seat"] = [];
          timeary[dayname][each_slot_timing]["online_restro"] = [];
          timeary[dayname][each_slot_timing]["onoff_restro"] = [];

          const idv = each_slot_timing.split("timeRow");
          if (Number(count_array) < Number(idv[1])) {
            count_array = idv[1];
          }
          console.log(idv[1]);
          timeary[dayname][each_slot_timing]["default_discount"] = $(
            ".discount_input_head" + idv[1]
          ).val();
          timeary[dayname][each_slot_timing]["guest_arrival"] = $(
            ".guest_arrival" + idv[1]
          ).val();
          timeary[dayname][each_slot_timing]["default_total_seat"] = $(
            ".total_seat_input_head" + idv[1]
          ).val();
          if (
            $(".online_input_insde" + idv[1] + "_top").val() === "undefined" ||
            $(".online_input_insde" + idv[1] + "_top").val() === ""
          ) {
            timeary[dayname][each_slot_timing]["default_online_restro"] =
              "false";
          } else {
            timeary[dayname][each_slot_timing]["default_online_restro"] = $(
              ".online_input_insde" + idv[1] + "_top"
            ).val();
          }

          if (
            $(".Restro_input_insde" + idv[1] + "_top").val() === "undefined" ||
            $(".Restro_input_insde" + idv[1] + "_top").val() === ""
          ) {
            timeary[dayname][each_slot_timing]["default_onoff_restro"] =
              "false";
          } else {
            timeary[dayname][each_slot_timing]["default_onoff_restro"] = $(
              ".Restro_input_insde" + idv[1] + "_top"
            ).val();
          }

          timeary[dayname][each_slot_timing]["default_apply_same_checkbox"] =
            isChecked[idv[1]]; //apply the same value checkbox
          timeary[dayname][each_slot_timing]["start_time"] = $(
            ".start_time" + idv[1]
          ).val();
          timeary[dayname][each_slot_timing]["end_time"] = $(
            ".end_time" + idv[1]
          ).val();

          if (
            $(".start_time" + idv[1]).val() == $(".end_time" + idv[1]).val() ||
            $(".start_time" + idv[1]).val() > $(".end_time" + idv[1]).val()
          ) {
            $(".start_time" + idv[1]).addClass("emptyInputError");
            $(".end_time" + idv[1]).addClass("emptyInputError");
            vaild_data_three = 1;
          }

          $(this)
            .find(".timeli")
            .each(function () {
              if (!$(this).hasClass("timeli_hide")) {
                const timeval = $(this).find(".timing_input").val();
                const tmtre = $(this);
                //const tmtre = $('.'+timeval.replace(":", "_"));
                //console.log(tmtre.attr('key'))
                const discount_input_lp = tmtre
                  .find(".discount_input" + idv[1])
                  .val();
                const total_seat_input_lp = tmtre
                  .find(".total_seat_input" + idv[1])
                  .val();
                if (discount_input_lp < 0 || discount_input_lp == "") {
                  tmtre
                    .find(".discount_input" + idv[1])
                    .addClass("emptyInputError");
                  vaild_data_one = 1;
                }
                if (total_seat_input_lp < 1 || total_seat_input_lp == "") {
                  tmtre
                    .find(".total_seat_input" + idv[1])
                    .addClass("emptyInputError");
                  vaild_data_one = 1;
                }

                timeary[dayname][each_slot_timing]["timing"].push(timeval);
                timeary[dayname][each_slot_timing]["discount"].push(
                  discount_input_lp
                );
                timeary[dayname][each_slot_timing]["total_seat"].push(
                  total_seat_input_lp
                );

                if (
                  tmtre.find(".online_input_insde").val() === "undefined" ||
                  tmtre.find(".online_input_insde").val() === ""
                ) {
                  timeary[dayname][each_slot_timing]["online_restro"].push(
                    "false"
                  );
                } else {
                  timeary[dayname][each_slot_timing]["online_restro"].push(
                    tmtre.find(".online_input_insde").val()
                  );
                }

                if (
                  tmtre.find(".Restro_input_insde").val() === "undefined" ||
                  tmtre.find(".Restro_input_insde").val() === ""
                ) {
                  timeary[dayname][each_slot_timing]["onoff_restro"].push(
                    "false"
                  );
                } else {
                  timeary[dayname][each_slot_timing]["onoff_restro"].push(
                    tmtre.find(".Restro_input_insde").val()
                  );
                }

                for_duplicate[dayname][each_slot_timing].push(timeval);
              }
            });
        }
      });

    const hasDuplicates = (array) => {
      const set = new Set(array);
      return set.size !== array.length;
    };
    let duplicate_have = "";
    let vaild_data_two = 0;
    for (const day in for_duplicate) {
      const allTimeSlots = Object.values(for_duplicate[day]).flat();

      if (hasDuplicates(allTimeSlots)) {
        //console.log(`Duplicates found for ${day}: ${allTimeSlots}`);
        duplicate_have = duplicate_have + "," + day;
        vaild_data_two = 1;
      }
    }

    let error_empty = "";
    if (vaild_data_two == 1) {
      handleError(
        "Duplicate Time Slot Find For " + duplicate_have.substring(1)
      );
    } else if (vaild_data_one == 1) {
      handleError("Please Fill the mandatory field");
    } else if (vaild_data_three == 1) {
      handleError("Please Check Start Time and End Time");
    } else {
      setshowLoaderAdmin(true);
      let fd_from = new FormData();

      [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ].forEach((day) => {
        let data_make = -1;
        for (let q = 0; q <= count_array; q++) {
          try {
            let data_get = timeary[day]["timeRow" + q];
            if (data_get) {
              data_make++;
              let j = data_make;
              let ssss = data_get["default_total_seat"];
              fd_from.append(day + "default_total_seat" + j, ssss);
              fd_from.append(
                day + "default_discount" + j,
                data_get["default_discount"]
              );
              fd_from.append(day + "start_time" + j, data_get["start_time"]);
              fd_from.append(day + "end_time" + j, data_get["end_time"]);
              fd_from.append(
                day + "guest_arrival" + j,
                data_get["guest_arrival"]
              );

              let online_booking_status =
                data_get["default_online_restro"] === "true" ? "1" : "0";

              fd_from.append(
                day + "online_booking_status" + j,
                online_booking_status
              );

              let start_stop_status =
                data_get["default_onoff_restro"] === "true" ? "1" : "0";

              fd_from.append(day + "start_stop_status" + j, start_stop_status);
              let timing_loop = timeary[day]["timeRow" + q]["timing"];
              let discount_loop = timeary[day]["timeRow" + q]["discount"];
              let online_loop = timeary[day]["timeRow" + q]["online_restro"];
              let onoff_loop = timeary[day]["timeRow" + q]["onoff_restro"];
              let total_seat_loop = timeary[day]["timeRow" + q]["total_seat"];
              fd_from.append(day + "time_loop_count" + j, timing_loop.length);
              if (timing_loop.length == 0) {
                error_empty = day;
              }
              for (let k = 0; k < timing_loop.length; k++) {
                fd_from.append(
                  day + "start_time_loop" + j + "" + k,
                  timing_loop[k]
                );
                fd_from.append(
                  day + "discount_loop" + j + "" + k,
                  discount_loop[k]
                );
                let online_booking_status =
                  online_loop[k] === "true" ? "1" : "0";
                fd_from.append(
                  day + "online_loop" + j + "" + k,
                  online_booking_status
                );
                let onoff_loop_status = onoff_loop[k] === "true" ? "1" : "0";
                fd_from.append(
                  day + "onoff_loop" + j + "" + k,
                  onoff_loop_status
                );
                fd_from.append(
                  day + "total_seat_loop" + j + "" + k,
                  total_seat_loop[k]
                );
              }
            }
          } catch (err) {
            //error handling
          }
        }
        fd_from.append(day + "total_timing_add", data_make);
      });

      for (const [key, value] of Object.entries(week_online_data)) {
        fd_from.append("week_online_data_" + key, value);
      }

      for (const [key, value] of Object.entries(week_close_data)) {
        fd_from.append("week_close_data_" + key, value);
      }

      for (const pair of fd_from.entries()) {
        //  console.log(pair[0] + ": " + pair[1]);
      }
      if (error_empty !== "") {
        handleError("please fill mandatory field (" + error_empty + ")");
        setshowLoaderAdmin(false);
      } else {
        fd_from.append("default_restaurant_id", default_restaurant_id_staff);
        fd_from.append("click_from_onboarding", "1");
        fd_from.append("from_come", "1");
        await server_post_data(url_for_save, fd_from)
          .then((Response) => {
            setshowLoaderAdmin(false);
            if (Response.data.error) {
              handleError(Response.data.message);
            } else {
              nextStep();
            }
          })
          .catch((error) => {
            handleError("network");
            setshowLoaderAdmin(false);
          });
      }
    }
  };

  const handleOnlineBooking = () => {
    setIsOnlineOn(!isOnlineOn);
  };

  const handleSpecialHrBooking = (index, indexi, from_where = 0) => {
    setIsSpecialOnlineOn((prevState) => {
      const updatedState = { ...prevState };
      const keyim = `${index}_${indexi}`;
      if (from_where == 0) {
        //if added new field with plus icon
        if (!updatedState.hasOwnProperty(keyim)) {
          console.log($(".online_input_insde" + keyim).val());
          if ($(".online_input_insde" + keyim).val() === "true") {
            console.log("not come in true");
            updatedState[keyim] = false;
          } else {
            updatedState[keyim] = true;
          }
          $(".online_input_insde" + keyim).remove();
          $(".Online_Booking_Off_inside" + keyim).append(
            `<input type="hidden" class="online_input_insde online_input_insde${keyim}" value="${isSpecialOnlineOn[keyim]}">`
          );
        } else {
          updatedState[keyim] = !updatedState[keyim];
        }
      } else {
        updatedState[keyim] = !updatedState[keyim];
      }
      if (updatedState[keyim] == true) {
        $(".BorderedGlobe_" + keyim).addClass("normal_hide");
        $(".CrossedGlobe_" + keyim).removeClass("normal_hide");
        $(".online_input_insde" + keyim).val(true);
      } else {
        console.log(keyim);
        $(".BorderedGlobe_" + keyim).removeClass("normal_hide");
        $(".CrossedGlobe_" + keyim).addClass("normal_hide");
        $(".online_input_insde" + keyim).val(false);
      }
      return updatedState;
    });
  };

  const handleRestroOpenInside = (index, indexi, from_where = 0) => {
    setIsRestroOpeninside((prevState) => {
      const updatedState = { ...prevState };
      const keyim = `${index}_${indexi}`;
      if (from_where == 0) {
        //if added new field with plus icon
        if (!updatedState.hasOwnProperty(keyim)) {
          console.log($(".Restro_input_insde" + keyim).val());
          if ($(".Restro_input_insde" + keyim).val() === "true") {
            console.log("not come in true");
            updatedState[keyim] = false;
          } else {
            updatedState[keyim] = true;
          }
          $(".Restro_input_insde" + keyim).remove();
          $(".Close_Restaurant_inside" + keyim).append(
            `<input type="hidden" class="Restro_input_insde Restro_input_insde${keyim}" value="${isRestroOpeninside[keyim]}">`
          );
        } else {
          updatedState[keyim] = !updatedState[keyim];
        }
      } else {
        updatedState[keyim] = !updatedState[keyim];
      }
      if (updatedState[keyim] == true) {
        $(".Restro_onbtn_insde" + keyim).addClass("normal_hide");
        $(".Restro_closebtn_insde" + keyim).removeClass("normal_hide");
        $(".Restro_input_insde" + keyim).val(true);
      } else {
        console.log(keyim);
        $(".Restro_onbtn_insde" + keyim).removeClass("normal_hide");
        $(".Restro_closebtn_insde" + keyim).addClass("normal_hide");
        $(".Restro_input_insde" + keyim).val(false);
      }
      return updatedState;
    });
  };

  const formatDate = (date) => {
    if (!date) {
      return ""; // Handle the case when date is undefined
    }
    const options = { weekday: "long", day: "numeric", month: "long" };
    const formattedDate = date.toLocaleString(undefined, options);
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  };
  const checkboxValues = [false, false, false];

  const [specailHours, setSpecialHours] = useState(false);
  const [operationalHours, setOperationalHours] = useState(true);

  const toggleSpecailHours = (TabId) => {
    setOperationalHours(TabId === "1");
    setSpecialHours(TabId === "2");
  };

  console.log(dayData);
  const [currentDayIdx, setCurrentDayIdx] = useState(0);

  const handleCurrentDayInc = (idx) => {
    if (idx === 6) {
      setCurrentDayIdx(0);
    } else {
      setCurrentDayIdx(idx + 1);
    }
  };

  const handleCurrentDayDec = (idx) => {
    if (idx === 0) {
      setCurrentDayIdx(6);
    } else {
      setCurrentDayIdx(idx - 1);
    }
  };

  return (
    <div className="mt-3">
      <div className="containerRight">
        <div className="rightHeading">
          <div className="d-flex BackHeading">
            <button onClick={prevStep}>
              <img
                src={backButton}
                className="backSTepOPrationImg"
                alt="Back Button"
              />
            </button>
            <h3>Operational Hours</h3>
          </div>
        </div>
        <div className="overflowHeightOperationHour">
          <div className="ContentHours">
            {dayData &&
              dayData.length > 0 &&
              dayData[currentDayIdx] != "undefined" &&
              dayData[currentDayIdx].day && (
                <>
                  <div className="modalDatePicker">
                    <div className="divleft d-flex">
                      <div className="navigatorDayCont">
                        <img
                          src={PrevArrow}
                          onClick={() => handleCurrentDayDec(currentDayIdx)}
                          alt="Barley's Dashboard"
                        />
                        <div className="person__calenderFrame_image image_icon_date">
                          <div className="weekdayOpenCLose">
                            {dayData &&
                              dayData[currentDayIdx] != "undefined" &&
                              dayData.length > 0 && (
                                <h6 className="weekdayHead colorText">
                                  {" "}
                                  {dayData[currentDayIdx].day}{" "}
                                </h6>
                              )}
                          </div>
                        </div>
                        <img
                          src={NextArrow}
                          onClick={() => handleCurrentDayInc(currentDayIdx)}
                          alt="Barley's Dashboard"
                        />
                      </div>
                      <div
                        className="onlineImg selectGuestArrival"
                        style={{ gap: "6px", marginLeft: "9px" }}
                      >
                        <button
                          style={{ padding: "0" }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="left"
                          htmlFor={currentDayIdx}
                          title={` Online Booking Off`}
                          className={`Online_Booking_Off  `}
                          onClick={(e) => {
                            handleCheckboxWeekChange(
                              e,
                              dayData[currentDayIdx].day
                            );
                          }}
                        >
                          <img
                            src={BorderedGlobe}
                            alt="Barley's Dashboard"
                            className={`BorderedGlobe_${
                              dayData[currentDayIdx].day
                            }_main BorderedGlobe ${
                              isWeekOnlineChecked[dayData[currentDayIdx].day]
                                ? "normal_hide"
                                : ""
                            }`}
                          />
                          <img
                            src={CrossedGlobe}
                            alt="Barley's Dashboard"
                            className={`CrossedGlobe_${
                              dayData[currentDayIdx].day
                            }_main CrossedGlobe ${
                              !isWeekOnlineChecked[dayData[currentDayIdx].day]
                                ? "normal_hide"
                                : ""
                            }`}
                          />
                          <input
                            type="hidden"
                            dayattr={`${dayData[currentDayIdx].day}`}
                            defaultValue={`${
                              isWeekOnlineChecked[dayData[currentDayIdx].day]
                            }`}
                            className={`online_input_insde${dayData[currentDayIdx].day}_main online_input_insde online_input_insde_main`}
                          />
                        </button>

                        <button
                          style={{ padding: "0" }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="left"
                          htmlFor={currentDayIdx}
                          title={` Open Restaurant `}
                          className={`Close_Restaurant `}
                          onClick={(e) => {
                            handleCheckboxWeekCloseChange(
                              e,
                              dayData[currentDayIdx].day
                            );
                          }}
                        >
                          <img
                            src={BorderedOn}
                            alt="Barley's Dashboard"
                            className={`Restro_onbtn_insde${
                              dayData[currentDayIdx].day
                            }_main Restro_onbtn_insde ${
                              isWeekCloseChecked[dayData[currentDayIdx].day]
                                ? "normal_hide"
                                : ""
                            }`}
                          />

                          <img
                            src={CrossedOn}
                            alt="Barley's Dashboard"
                            className={`Restro_closebtn_insde${
                              dayData[currentDayIdx].day
                            }_main Restro_closebtn_insde ${
                              !isWeekCloseChecked[dayData[currentDayIdx].day]
                                ? "normal_hide"
                                : ""
                            }`}
                          />

                          <input
                            type="hidden"
                            dayattr={`${dayData[currentDayIdx].day}`}
                            defaultValue={`${
                              isWeekCloseChecked[dayData[currentDayIdx].day]
                            }`}
                            className={`Restro_input_insde Restro_input_insde${dayData[currentDayIdx].day}_main Restro_input_insde_main`}
                          />
                        </button>
                      </div>
                    </div>
                    <div className="divRight d-flex">
                      <img
                        src={LKTicn}
                        alt="tooltip"
                        className="tooltip-image"
                      />
                      <div className="tooltiptext">LKT</div>
                    </div>
                  </div>
                  <div className="contntBox">
                    <div className="timeEditTable PaddingNoneClass">
                      <div className="timeEditTable-container">
                        <div className="mt-4">
                          <div className="mainhd">
                            {dayData &&
                              dayData[currentDayIdx].day &&
                              dayData.length > 0 && (
                                <div
                                  key={currentDayIdx}
                                  className={`weekdayDiv weekdayDiv${dayData[currentDayIdx].day}`}
                                  style={{ overflow: "auto" }}
                                >
                                  {(() => {
                                    let index_for_first = -1;
                                    let index_first = -1;
                                    return dataloop.map((itemlist, index) => {
                                      if (
                                        itemlist.week_name ===
                                        dayData[currentDayIdx].day
                                      ) {
                                        index_for_first = index;
                                        let end_time =
                                          itemlist.end_time.substring(
                                            0,
                                            itemlist.end_time.length - 3
                                          );
                                        let start_time =
                                          itemlist.start_time.substring(
                                            0,
                                            itemlist.start_time.length - 3
                                          );
                                        let last_arrival_time =
                                          itemlist.last_arrival_time.substring(
                                            0,
                                            itemlist.last_arrival_time.length -
                                              3
                                          );
                                        let online_booking_status_top =
                                          itemlist.online_booking_status === 1
                                            ? true
                                            : false;
                                        let start_stop_status_top =
                                          itemlist.start_stop_status === 1
                                            ? true
                                            : false;

                                        index_first++;
                                        return (
                                          <div
                                            className={`timeRow timeRow${index} ${
                                              isWeekCloseChecked[
                                                dayData[currentDayIdx].day
                                              ]
                                                ? "unclickable"
                                                : ""
                                            }`}
                                            id={`timeRow${index}`}
                                            key={index}
                                          >
                                            <input
                                              type="hidden"
                                              className={`dayname dayname${index}`}
                                              value={`${dayData[currentDayIdx].day}`}
                                            />
                                            <div className="row m-0 -m overFLowClass">
                                              <div className="col-md-11 paddingRight0">
                                                <div className="timingsRowBodyContainer">
                                                  <div
                                                    className="accordion"
                                                    id="accordionPanelsStayOpenExample"
                                                  >
                                                    <div className="accordion-item">
                                                      <div className="timingsRowBody accordion-header paddingTOp">
                                                        <div className="d-flex align-items-center flex-nowrap overFdiv ">
                                                          <div className="row m-0 d-flex align-items-center flex-nowrap w-100">
                                                            <div className="timings_inputs me-3">
                                                              <div className="textDeco">
                                                                <button
                                                                  className="accordion-button collapsed"
                                                                  type="button"
                                                                  data-bs-toggle="collapse"
                                                                  data-bs-target={`#panelsStayOpen-collapseOne${index}`}
                                                                  aria-expanded="false"
                                                                  aria-controls={`#panelsStayOpen-collapseOne${index}`}
                                                                ></button>
                                                                <div className="txt">
                                                                  <label>
                                                                    Open at
                                                                  </label>
                                                                  <select
                                                                    type="time"
                                                                    name="name"
                                                                    className={`start_time${index}`}
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      generateTimings(
                                                                        index
                                                                      );
                                                                    }}
                                                                    defaultValue={
                                                                      start_time
                                                                    }
                                                                  >
                                                                    {TabletimingsList.length >
                                                                      0 &&
                                                                      TabletimingsList.map(
                                                                        (
                                                                          timenx,
                                                                          indexio
                                                                        ) => (
                                                                          <option
                                                                            value={
                                                                              timenx
                                                                            }
                                                                            key={
                                                                              indexio
                                                                            }
                                                                          >
                                                                            {
                                                                              timenx
                                                                            }
                                                                          </option>
                                                                        )
                                                                      )}
                                                                  </select>
                                                                </div>
                                                                <div className="txtt2">
                                                                  <label>
                                                                    Closed at
                                                                  </label>
                                                                  <select
                                                                    type="time"
                                                                    name="name"
                                                                    className={`end_time${index}`}
                                                                    defaultValue={
                                                                      end_time
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      generateTimings(
                                                                        index
                                                                      );
                                                                    }}
                                                                  >
                                                                    {TabletimingsList.length >
                                                                      0 &&
                                                                      TabletimingsList.map(
                                                                        (
                                                                          timenx,
                                                                          indexio
                                                                        ) => (
                                                                          <option
                                                                            value={
                                                                              timenx
                                                                            }
                                                                            key={
                                                                              indexio
                                                                            }
                                                                          >
                                                                            {
                                                                              timenx
                                                                            }
                                                                          </option>
                                                                        )
                                                                      )}
                                                                  </select>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="discountinput marginn  ">
                                                            <label>
                                                              Discount
                                                            </label>
                                                            <input
                                                              type="text"
                                                              minLength={1}
                                                              maxLength={2}
                                                              className={`discount_input_head${index} discount_input_head`}
                                                              defaultValue={
                                                                itemlist.per_discount_main
                                                              }
                                                              onBlur={(e) => {
                                                                discount_totl_st_chng(
                                                                  e,
                                                                  index,
                                                                  "discount",
                                                                  "default"
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                          <div className="discountinput">
                                                            <label>Seat</label>
                                                            <input
                                                              type="text"
                                                              minLength={1}
                                                              maxLength={3}
                                                              className={`total_seat_input_head${index} total_seat_input_head`}
                                                              defaultValue={
                                                                itemlist.per_day_maximum
                                                              }
                                                              onBlur={(e) => {
                                                                discount_totl_st_chng(
                                                                  e,
                                                                  index,
                                                                  "total_seat",
                                                                  "default"
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                          <div className="onlineImg selectGuestArrival marginnLeft">
                                                            <label>LKT</label>
                                                            <select
                                                              className={`guest_arrival${index}`}
                                                              defaultValue={
                                                                last_arrival_time
                                                              }
                                                            >
                                                              <option
                                                                value={`${last_arrival_time}`}
                                                              >
                                                                {
                                                                  last_arrival_time
                                                                }
                                                              </option>
                                                            </select>
                                                          </div>
                                                          <div className="onlineImg selectGuestArrival FlexColunm me-3">
                                                            <button
                                                              data-bs-toggle="tooltip"
                                                              data-bs-placement="left"
                                                              htmlFor="top"
                                                              title={`${
                                                                !isSpecialOnlineOn[
                                                                  index + "_top"
                                                                ]
                                                                  ? "Online Booking On"
                                                                  : "Online Booking Off"
                                                              }`}
                                                              className={`Online_Booking_Off Online_Booking_Off_inside${index}_top `}
                                                              onClick={() =>
                                                                handleSpecialHrBooking(
                                                                  index,
                                                                  "top"
                                                                )
                                                              }
                                                            >
                                                              <img
                                                                src={
                                                                  BorderedGlobe
                                                                }
                                                                alt="Barley's Dashboard"
                                                                className={`BorderedGlobe_${index}_top BorderedGlobe ${
                                                                  online_booking_status_top
                                                                    ? "normal_hide"
                                                                    : ""
                                                                }`}
                                                              />
                                                              <img
                                                                src={
                                                                  CrossedGlobe
                                                                }
                                                                alt="Barley's Dashboard"
                                                                className={`CrossedGlobe_${index}_top CrossedGlobe ${
                                                                  !online_booking_status_top
                                                                    ? "normal_hide"
                                                                    : ""
                                                                }`}
                                                              />
                                                              <input
                                                                type="hidden"
                                                                defaultValue={`${online_booking_status_top}`}
                                                                className={`online_input_insde${index}_top online_input_insde`}
                                                              />
                                                            </button>
                                                            <button
                                                              data-bs-toggle="tooltip"
                                                              data-bs-placement="left"
                                                              htmlFor="top"
                                                              title={`${
                                                                !isRestroOpeninside[
                                                                  index + "_top"
                                                                ]
                                                                  ? "Close Restaurant"
                                                                  : "Open Restaurant"
                                                              }`}
                                                              className={`Close_Restaurant Close_Restaurant_inside${index}_top`}
                                                              onClick={() =>
                                                                handleRestroOpenInside(
                                                                  index,
                                                                  "top"
                                                                )
                                                              }
                                                            >
                                                              <img
                                                                src={BorderedOn}
                                                                alt="Barley's Dashboard"
                                                                className={`Restro_onbtn_insde${index}_top Restro_onbtn_insde ${
                                                                  start_stop_status_top
                                                                    ? "normal_hide"
                                                                    : ""
                                                                }`}
                                                              />
                                                              <img
                                                                src={CrossedOn}
                                                                alt="Barley's Dashboard"
                                                                className={`Restro_closebtn_insde${index}_top Restro_closebtn_insde ${
                                                                  !start_stop_status_top
                                                                    ? "normal_hide"
                                                                    : ""
                                                                }`}
                                                              />
                                                              <input
                                                                type="hidden"
                                                                value={`${start_stop_status_top}`}
                                                                className={`Restro_input_insde Restro_input_insde${index}_top`}
                                                              />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div
                                                        id={`panelsStayOpen-collapseOne${index}`}
                                                        className="accordion-collapse collapse"
                                                      >
                                                        <div className="accordion-body timeDropdownBody">
                                                          {TabletimingsList.length >
                                                            0 && (
                                                            <ul>
                                                              {TabletimingsList.map(
                                                                (
                                                                  time,
                                                                  indexi
                                                                ) => {
                                                                  const backendData =
                                                                    dataloopdetails[
                                                                      itemlist
                                                                        .primary_id
                                                                    ];
                                                                  //console.log('Backend Data:', backendData);
                                                                  const backendTime =
                                                                    backendData
                                                                      ? backendData.find(
                                                                          (
                                                                            backend_time
                                                                          ) =>
                                                                            backend_time.start_time.substring(
                                                                              0,
                                                                              5
                                                                            ) ===
                                                                            time
                                                                        )
                                                                      : undefined;
                                                                  ///console.log("Matching Backend Time:",itemlist);
                                                                  //console.log(backendTime);
                                                                  const dis_vl =
                                                                    backendTime
                                                                      ? backendTime.per_discount
                                                                      : "";
                                                                  const seat_vl =
                                                                    backendTime
                                                                      ? backendTime.per_day_maximum_particular
                                                                      : "";
                                                                  const hdsh =
                                                                    backendTime
                                                                      ? backendTime.per_day_maximum_particular
                                                                      : "timeli_hide";

                                                                  let online_booking_status_inside =
                                                                    backendTime
                                                                      ? backendTime.online_booking_time_status ===
                                                                        1
                                                                        ? true
                                                                        : false
                                                                      : false;

                                                                  let start_stop_status_inside =
                                                                    backendTime
                                                                      ? backendTime.start_stop_time_status ===
                                                                        1
                                                                        ? true
                                                                        : false
                                                                      : false;

                                                                  /*  isSpecialOnlineOn[index + "_" + indexi] = backendTime
                                                  ? backendTime.online_booking_time_status === 1
                                                    ? true
                                                    : false
                                                  : false;


                                                  isRestroOpeninside[index + "_" + indexi] = backendTime
                                                  ? backendTime.start_stop_time_status === 1
                                                    ? true
                                                    : false
                                                  : false; */

                                                                  return (
                                                                    <li
                                                                      key={
                                                                        indexi
                                                                      }
                                                                      className={`timeli ${time.replace(
                                                                        ":",
                                                                        "_"
                                                                      )} ${hdsh}`}
                                                                    >
                                                                      <div className="timeSlotsDiv">
                                                                        <div className="row m-0">
                                                                          <div className="col-md-7 col-7">
                                                                            <div className="timeSlot">
                                                                              <img
                                                                                src={
                                                                                  Watch
                                                                                }
                                                                                alt="Barley's Dashboard"
                                                                              />
                                                                              <p
                                                                                style={{
                                                                                  padding:
                                                                                    "0",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  time
                                                                                }
                                                                                <input
                                                                                  type="hidden"
                                                                                  value={
                                                                                    time
                                                                                  }
                                                                                  className="timing_input"
                                                                                />
                                                                              </p>
                                                                            </div>
                                                                          </div>
                                                                          <div
                                                                            className="col-md-2 col-2"
                                                                            style={{
                                                                              paddingLeft:
                                                                                "2px",
                                                                            }}
                                                                          >
                                                                            <div className="discountinput">
                                                                              <input
                                                                                type="text"
                                                                                minLength={
                                                                                  1
                                                                                }
                                                                                maxLength={
                                                                                  2
                                                                                }
                                                                                className={`discount_input${index} discount_input`}
                                                                                onBlur={(
                                                                                  e
                                                                                ) => {
                                                                                  discount_totl_st_chng(
                                                                                    e,
                                                                                    index,
                                                                                    "discount",
                                                                                    "inside_input"
                                                                                  );
                                                                                }}
                                                                                defaultValue={
                                                                                  dis_vl
                                                                                }
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                          <div className="col-md-2 col-2">
                                                                            <div className="discountinput">
                                                                              <input
                                                                                type="text"
                                                                                minLength={
                                                                                  1
                                                                                }
                                                                                maxLength={
                                                                                  3
                                                                                }
                                                                                className={`total_seat_input${index} total_seat_input`}
                                                                                onBlur={(
                                                                                  e
                                                                                ) => {
                                                                                  discount_totl_st_chng(
                                                                                    e,
                                                                                    index,
                                                                                    "total_seat",
                                                                                    "inside_input"
                                                                                  );
                                                                                }}
                                                                                defaultValue={
                                                                                  seat_vl
                                                                                }
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                          {/* <div className="col-md-2">
                                                                      <div
                                                                        className="onlineImg selectGuestArrival"
                                                                        style={{
                                                                          paddingLeft:
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        <select className="opacity0">
                                                                          <option>
                                                                            Last
                                                                            Resrvation
                                                                            Time
                                                                          </option>
                                                                        </select>
                                                                      </div>
                                                                    </div> */}
                                                                          <div className="col-md-1 col-1">
                                                                            <div
                                                                              className="onlineImg selectGuestArrival d-flex flex-column"
                                                                              style={{
                                                                                paddingLeft:
                                                                                  "16px",
                                                                              }}
                                                                            >
                                                                              <button
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-placement="left"
                                                                                htmlFor={
                                                                                  indexi
                                                                                }
                                                                                title={`${
                                                                                  !isSpecialOnlineOn[
                                                                                    index +
                                                                                      "_" +
                                                                                      indexi
                                                                                  ]
                                                                                    ? "Online Booking On "
                                                                                    : "Online Booking Off"
                                                                                }`}
                                                                                className={`Online_Booking_Off Online_Booking_Off_inside${index}_${indexi} `}
                                                                                onClick={() =>
                                                                                  handleSpecialHrBooking(
                                                                                    index,
                                                                                    indexi
                                                                                  )
                                                                                }
                                                                              >
                                                                                <img
                                                                                  src={
                                                                                    BorderedGlobe
                                                                                  }
                                                                                  alt="Barley's Dashboard"
                                                                                  className={`BorderedGlobe_${index}_${indexi} BorderedGlobe ${
                                                                                    online_booking_status_inside
                                                                                      ? "normal_hide"
                                                                                      : ""
                                                                                  }`}
                                                                                />
                                                                                <img
                                                                                  src={
                                                                                    CrossedGlobe
                                                                                  }
                                                                                  alt="Barley's Dashboard"
                                                                                  className={`CrossedGlobe_${index}_${indexi} CrossedGlobe ${
                                                                                    !online_booking_status_inside
                                                                                      ? "normal_hide"
                                                                                      : ""
                                                                                  }`}
                                                                                />
                                                                                <input
                                                                                  type="hidden"
                                                                                  defaultValue={`${online_booking_status_inside}`}
                                                                                  className={`online_input_insde online_input_insde${index}_${indexi} `}
                                                                                />
                                                                              </button>

                                                                              <button
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-placement="left"
                                                                                htmlFor={
                                                                                  indexi
                                                                                }
                                                                                title={`${
                                                                                  !isRestroOpeninside[
                                                                                    index +
                                                                                      "_" +
                                                                                      indexi
                                                                                  ]
                                                                                    ? "Close Restaurant"
                                                                                    : "Open Restaurant"
                                                                                }`}
                                                                                className={`Close_Restaurant Close_Restaurant_inside${index}_${indexi}`}
                                                                                onClick={() =>
                                                                                  handleRestroOpenInside(
                                                                                    index,
                                                                                    indexi
                                                                                  )
                                                                                }
                                                                              >
                                                                                <img
                                                                                  src={
                                                                                    BorderedOn
                                                                                  }
                                                                                  alt="Barley's Dashboard"
                                                                                  className={`Restro_onbtn_insde${index}_${indexi} Restro_onbtn_insde ${
                                                                                    start_stop_status_inside
                                                                                      ? "normal_hide"
                                                                                      : ""
                                                                                  }`}
                                                                                />

                                                                                <img
                                                                                  src={
                                                                                    CrossedOn
                                                                                  }
                                                                                  alt="Barley's Dashboard"
                                                                                  className={`Restro_closebtn_insde${index}_${indexi} Restro_closebtn_insde ${
                                                                                    !start_stop_status_inside
                                                                                      ? "normal_hide"
                                                                                      : ""
                                                                                  }`}
                                                                                />
                                                                                <input
                                                                                  type="hidden"
                                                                                  value={`${start_stop_status_inside}`}
                                                                                  className={`Restro_input_insde Restro_input_insde${index}_${indexi}`}
                                                                                />
                                                                              </button>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </li>
                                                                  );
                                                                }
                                                              )}
                                                            </ul>
                                                          )}
                                                        </div>
                                                      </div>
                                                      <div className="applyTheSameSec">
                                                        <div className="no_prsnl_id p-0">
                                                          <div className="rememberMe">
                                                            <input
                                                              type="checkbox"
                                                              id={`time_checkbox${index}`}
                                                              className={`hidden hidden-checkbox hidden-checkbox${index}`}
                                                              checked={
                                                                isChecked[index]
                                                              }
                                                              onChange={(e) => {
                                                                handleCheckboxChange(
                                                                  e,
                                                                  index
                                                                );
                                                              }}
                                                            />
                                                            <label
                                                              htmlFor={`time_checkbox${index}`}
                                                              className="checkbox-labelTiming labelCheckbox"
                                                            >
                                                              Apply the same
                                                              value for All
                                                              Timeslots
                                                            </label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="col-1">
                                                <div className="addTimingRowContainer">
                                                  <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="left"
                                                    forhtml={
                                                      dayData[currentDayIdx].day
                                                    }
                                                    title="Add Time Row"
                                                    className={`AddTimeRow Add_time_row Add_time_row${index} ${
                                                      index_first !== 0
                                                        ? "hidden"
                                                        : "visible"
                                                    }`}
                                                    onClick={(e) => {
                                                      addnewrow(index);
                                                    }}
                                                  >
                                                    <img
                                                      src={AddIcon}
                                                      alt="Barley's Dashboard"
                                                    />
                                                  </button>
                                                  <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="left"
                                                    title="Delete Time Row"
                                                    className={`AddTimeRow deletetimeRow Delete_time_row Delete_time_row${index} ${
                                                      index_first === 0
                                                        ? "hidden"
                                                        : "visible"
                                                    }`}
                                                    onClick={(e) => {
                                                      handleShow1(index);
                                                    }}
                                                  >
                                                    <img
                                                      src={DeleteIcon}
                                                      alt="Barley's Dashboard"
                                                    />
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                      return null;
                                    });
                                  })()}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="footerbtttn fixNextButton">
                        <div className="container-lg d-flex justify-content-end gap-3">
                          <div
                            className="skipbutton"
                            onClick={() =>
                              handleSaveChangesdynamic(
                                "formsavetimining",
                                save_update_week_timing
                              )
                            }
                          >
                            <button>Skip</button>
                          </div>
                          <div className="NextButton ">
                            <button
                              onClick={() =>
                                handleSaveChangesdynamic(
                                  "formsavetimining",
                                  save_update_week_timing
                                )
                              }
                              style={{ margin: 0 }}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>

                      <Modal
                        show={modalShow1}
                        className="confirmModal confirmModal2"
                        centered
                        onHide={handleClose1}
                      >
                        <Modal.Header
                          className="confirmModalHeader"
                          closeButton
                        ></Modal.Header>
                        <Modal.Body className="confirmBody">
                          {/* <img src={DeactiIcon} alt="Barley's Dashboard" /> */}
                          <p className="modalText">
                            Are you Sure You want to Delete This Row?
                          </p>
                        </Modal.Body>
                        <Modal.Footer className="confirmModalFooter">
                          <Button onClick={handleClose1}>Cancel</Button>
                          <Button
                            className={`saveSpecialTimeBtn Save_Special_Time`}
                            onClick={deletenewrow}
                          >
                            Delete
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboadingstep9;
